
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DodaFront/View/JobSearchList",
      function () {
        return require("private-next-pages/DodaFront/View/JobSearchList/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DodaFront/View/JobSearchList"])
      });
    }
  